import globals from "/utils/globals";

export default url => {
  const { protocol, host } = window.location;
  let shareUrl = `${protocol}//${host}`;
  let anchor;

  if (url.indexOf("#") > 1) {
    anchor = url.slice(url.indexOf("#"));
    url = url.slice(0, url.indexOf("#"));
  }

  if (url.length > 0) {
    shareUrl += url + "?";
  } else {
    shareUrl += "?";
  }

  if (shareUrl.indexOf("highlights") >= 0) {
    shareUrl += "utm_medium=bk_blink&utm_source=bk_loop&utm_campaign=highlight";
  } else if (shareUrl.indexOf("insights") >= 0) {
    shareUrl += "utm_medium=bk_blink&utm_source=bk_loop&utm_campaign=chapter";
  } else if (shareUrl.indexOf("blinks") >= 0) {
    const slug = /blinks\/(.*)\//.exec(shareUrl)[1]; // Extract the slug
    shareUrl += "utm_medium=bk_book&utm_source=bk_loop&utm_campaign=" + slug;
  } else {
    shareUrl += "utm_medium=bk_referral&utm_source=bk_loop&utm_campaign=blinkist.com";
  }

  if (globals.configUserData && globals.configUserData.referrerToken) {
    shareUrl += "&referrer_token=" + globals.configUserData.referrerToken;
  }

  if (shareUrl.indexOf("#") > 1) {
    shareUrl = shareUrl.substring(shareUrl.indexOf("#"), shareUrl.indexOf("?"));
  }

  if (typeof anchor !== "undefined") {
    shareUrl += anchor;
  }

  return shareUrl;
};
